export default "__VITE_ASSET__mRK5ttkV__"